<template>
    <div class="block-manage-wrapper">
        <div>
            <div class="title">
                {{ title }}&nbsp;&nbsp;
                <el-button type="primary" round @click="addVideoTipClick">{{ $t("zhiji.wiki.addVideoTip") }}</el-button>
                <el-button type="primary" round @click="addDrainageClick">{{ $t("zhiji.wiki.addDrainage") }}</el-button>
            </div>
            <el-table :data="tableData" border width="500">
                <el-table-column prop="type" :label="$t('zhiji.wiki.type')"> </el-table-column>
                <el-table-column prop="sort" :label="$t('zhiji.wiki.sort')"> </el-table-column>
                <el-table-column prop="sectionTitle" :label="$t('zhiji.wiki.sectionTitle')"> </el-table-column>
                <el-table-column prop="picture" :label="$t('zhiji.wiki.picture')">
                    <template slot-scope="scope">
                        <a href="javascript:;" @click="viewClick(scope.row.image)" v-if="scope.row.sectionType != 'list'">{{
                            $t("zhiji.wiki.clickView")
                        }}</a>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="question" :label="$t('zhiji.wiki.question')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sectionType === 'banner'">{{ scope.row.question }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('zhiji.common.operate')" width="320">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="editClick(scope.row)">
                            {{ $t("zhiji.wiki.edit") }}
                        </el-button>
                        <el-button size="mini" @click="deleteClick(scope.row)">
                            {{ $t("zhiji.wiki.delete") }}
                        </el-button>
                        <el-button v-if="scope.row.sectionType === 'list'" size="mini" @click="moreClick(scope.row)">
                            {{ $t("zhiji.wiki.more") }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="page-control">
            <PageControl :total="count" :curPage="page" :pageLength="size" @pageChange="pageChange" />
            <div class="page-length-rank">
                <span class="total-num">{{ $t("zhiji.materialLibrary.totalOf") + count }}</span>
                <PageLengthSelect class="length-rank-robot" :pageRank="[10, 20, 50]" :curLength="size" @lengthChange="lengthChange" />
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import AddDrainageModal from "./AddDrainageModal";
import AddVideoTipModal from "./AddVideoTipModal";
import MoreBlockModal from "./MoreBlockModal/Index";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import PageLengthSelect from "@/views/zhiji/bComponents/pageController/PageLengthSelect";

export default {
    name: "MainPush",
    props: ["lang"],
    components: {
        AddDrainageModal,
        AddVideoTipModal,
        MoreBlockModal,
        PageControl,
        PageLengthSelect
    },
    data() {
        return {
            tableData: [],
            page: 1,
            size: 10,
            count: 0,
            curLang: "en"
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.wiki.blockManage");
        }
    },
    watch: {
        lang: {
            handler(val) {
                this.curLang = val;
                this.page = 1;
                this.querySectionList();
            },
            immediate: true
        },
        title() {
            this.page = 1;
            this.querySectionList();
        }
    },
    methods: {
        addVideoTipClick() {
            this.showVideoTipModal({
                title: this.$t("zhiji.wiki.addVideoTip"),
                lang: this.curLang
            });
        },
        showVideoTipModal({ title, id = "", formData = {}, lang }) {
            this.$store.dispatch("zhiji/showModal", {
                type: AddVideoTipModal,
                data: {
                    title,
                    formData,
                    id,
                    lang,
                    rules: {
                        sectionTitle: [{ required: true, message: this.$t("zhiji.wiki.error.blockTitle") }],
                        sort: [{ required: true, message: this.$t("zhiji.wiki.error.sort") }]
                    },
                    confirm: () => {
                        this.page = 1;
                        this.querySectionList();
                    }
                }
            });
        },
        addDrainageClick() {
            this.showDrainageModal({
                title: this.$t("zhiji.wiki.addDrainage"),
                lang: this.curLang
            });
        },
        showDrainageModal({ title, id = "", formData = {}, resourceId = "", lang, editId = "" }) {
            this.$store.dispatch("zhiji/showModal", {
                type: AddDrainageModal,
                data: {
                    title,
                    id,
                    formData,
                    lang,
                    editId,
                    resourceId,
                    rules: {
                        image: [{ required: true, message: this.$t("zhiji.wiki.error.image") }],
                        question: [{ required: true, message: this.$t("zhiji.wiki.error.question") }],
                        sort: [{ required: true, message: this.$t("zhiji.wiki.error.sort") }]
                    },
                    confirm: () => {
                        this.page = 1;
                        this.querySectionList();
                    }
                }
            });
        },
        editClick(data) {
            if (data.sectionType === "banner") {
                this.showDrainageModal({
                    title: this.$t("zhiji.wiki.editDrainage"),
                    id: data.id,
                    editId: data.editId,
                    lang: data.lang,
                    resourceId: data.resourceId,
                    formData: {
                        image: data.image,
                        question: {
                            question: data.question
                        },
                        sort: data.sort
                    }
                });
            } else if (data.sectionType === "list") {
                this.showVideoTipModal({
                    title: this.$t("zhiji.wiki.editVideoTip"),
                    id: data.id,
                    lang: data.lang,
                    formData: {
                        sort: data.sort,
                        sectionTitle: data.sectionTitle
                    }
                });
            }
        },
        deleteClick({id, type}) {
             this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: `${this.$t("zhiji.wiki.deleteTip1")}"${type}"${this.$t("zhiji.wiki.deleteTip2")}` ,
                    confirm: () => {
                        this.zhiji.requestByServiceName("deleteSection", { id }).then(() => {
                            this.page = 1;
                            this.querySectionList();
                        });
                    }
                }
            });
        },
        moreClick(rowData) {
            this.$store.dispatch("zhiji/showModal", {
                type: MoreBlockModal,
                data: {
                    rowData,
                    lang: this.curLang,
                    confirm: () => {}
                }
            });
        },
        pageChange(data) {
            if (this.size == data.pageLength && this.page == data.curPage) {
                return;
            }
            this.size = data.pageLength;
            this.page = data.curPage;
            this.querySectionList();
        },
        lengthChange(data) {
            if (this.size == data) {
                return;
            }
            this.size = data;
            this.page = 1;
            this.querySectionList();
        },
        viewClick(data) {
            data &&
                this.$store.commit("zhiji/showModal", {
                    type: "ImageViewModal",
                    data: {
                        url: data
                    }
                });
        },
        querySectionList() {
            this.zhiji
                .requestByServiceName("querySectionList", {
                    lang: this.curLang,
                    page: this.page,
                    size: this.size
                })
                .then(res => {
                    this.count = res.count;
                    this.tableData = res.list;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.block-manage-wrapper {
    max-width: 1390px;
    margin-top: 16px;
    border-bottom: 1px solid #d8e4f0;
    background: #fff;
    padding: 16px 16px 0;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    .title{
        margin-bottom: 16px;
    }
    .page-control {
        position: relative;
        width: 100%;
        padding: 20px 0;
        text-align: center;
        background: #fff;
        .page-length-rank {
            margin-right: 20px;
            float: right;
            margin-top: 6px;
            .total-num {
                font-weight: 700;
                margin-right: 10px;
            }
            .length-rank-robot {
                top: -2px;
            }
        }
    }
    /deep/.el-table thead tr th:first-child,
    /deep/.el-table tbody tr td:first-child{padding-left:10px;}
}
</style>
